import { render, staticRenderFns } from "./IndicadoresPESV.vue?vue&type=template&id=1bdfbe64&scoped=true"
import script from "./IndicadoresPESV.vue?vue&type=script&lang=js"
export * from "./IndicadoresPESV.vue?vue&type=script&lang=js"
import style0 from "./IndicadoresPESV.vue?vue&type=style&index=0&id=1bdfbe64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bdfbe64",
  null
  
)

export default component.exports